import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  order: {
    required,
  },
};

export default validations;